// Shared custom-spec limits for manual entry
export const customLimits = {
  cpu: { min: 1, max: 64, step: 1, default: 2 },
  ramGb: { min: 2, max: 512, step: 2, default: 4 },
  nvmeGb: { min: 0, max: 4000, step: 10, default: 50 },
  hddGb: { min: 0, max: 10000, step: 50, default: 0 },
  ips: { min: 0, max: 10, step: 1, default: 0 },
  quantity: { min: 1, max: 100, step: 1, default: 1 },
};
